import React, { useEffect, useState, useMemo } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import StoreService from '../components/StoreService';
import StockToFill from '../features/inventory/components/StockToFill';

const StockToFillPage = () => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [storeId, setStoreId] = useState('');

  useEffect(() => {
    let mounted = true;
    const fetchStores = async () => {
      setLoading(true);
      try {
        const response = await StoreService.fetchStores();
        const raw = response?.response || response || [];
        const normalized = raw.map(s => ({ id: String(s._id ?? s.id ?? ''), name: s.name || 'Magasin' })).filter(s => s.id);
        if (mounted) {
          setStores(normalized);
          setError('');
          setStoreId(normalized[0]?.id || '');
        }
      } catch (err) {
        if (mounted) setError(err?.message || 'Erreur lors du chargement des magasins');
      } finally {
        if (mounted) setLoading(false);
      }
    };
    fetchStores();
    return () => { mounted = false; };
  }, []);

  if (loading) return <Box display="flex" justifyContent="center" py={6}><CircularProgress size={28} /></Box>;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!stores.length) return <Alert severity="info">Aucun magasin disponible.</Alert>;

  return <StockToFill storeId={storeId} stores={stores} />;
};

export default StockToFillPage;
